import { Outlet, Link } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export default function Layout() {
  const { isAuthenticated, user, logout } = useAuthStore();

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-abyss-900/80 backdrop-blur-md shadow-lg border-b border-shark-800/50">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-3">
                <img src="/cardsharkie-logo.png" alt="CardSharkie Games" className="w-10 h-10 rounded-full ring-2 ring-shark-400/30" />
                <span className="brand-text-sm text-xl">CardSharkie</span>
              </Link>
              <div className="hidden md:flex ml-10 space-x-8">
                <Link to="/lobby" className="text-gray-300 hover:text-white px-3 py-2">
                  Play
                </Link>
                <Link to="/leaderboard" className="text-gray-300 hover:text-white px-3 py-2">
                  Leaderboard
                </Link>
                <Link to="/shop" className="text-gray-300 hover:text-white px-3 py-2">
                  Shop
                </Link>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              {isAuthenticated ? (
                user?.isGuest ? (
                  // Guest user - show upgrade options
                  <>
                    <span className="text-gray-400">
                      {user?.displayName || 'Guest'}
                    </span>
                    <Link
                      to="/login"
                      className="text-gray-300 hover:text-white px-4 py-2"
                    >
                      Login
                    </Link>
                    <Link
                      to="/register"
                      className="bg-shark-500 hover:bg-shark-600 text-white px-4 py-2 rounded-lg"
                    >
                      Sign Up
                    </Link>
                  </>
                ) : (
                  // Logged in user
                  <>
                    <Link to="/profile" className="text-gray-300 hover:text-white">
                      {user?.displayName || user?.username}
                    </Link>
                    <button
                      onClick={logout}
                      className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg"
                    >
                      Logout
                    </button>
                  </>
                )
              ) : (
                <>
                  <Link
                    to="/login"
                    className="text-gray-300 hover:text-white px-4 py-2"
                  >
                    Login
                  </Link>
                  <Link
                    to="/register"
                    className="bg-shark-500 hover:bg-shark-600 text-white px-4 py-2 rounded-lg"
                  >
                    Sign Up
                  </Link>
                </>
              )}
            </div>
          </div>
        </nav>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="bg-abyss-900/60 backdrop-blur-sm py-4 border-t border-shark-800/30">
        <div className="max-w-7xl mx-auto px-4 text-center text-gray-400">
          <p>&copy; 2025 CardSharkie Games. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
